import { createFileRoute, redirect } from "@tanstack/react-router";

// English schema alias: FAQPage → home FAQ section
export const Route = createFileRoute("/faq")({
  beforeLoad: () => {
    throw redirect({ to: "/", hash: "faq", replace: true });
  },
  component: () => null,
});
